import { render } from "./RescheduleRequest.vue?vue&type=template&id=0d5d135f&ts=true"
import script from "./RescheduleRequest.vue?vue&type=script&lang=ts"
export * from "./RescheduleRequest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__